export default __webpack_public_path__ + "static/media/clickup.7e5d4500.svg";